import angular from 'angular';

let counter = 0;

export default function switcher() {
  return function link($scope, $element, $attrs) {
    $element.attr('checked', $scope.$eval($attrs.ngModel));

    const id = $element.attr('id') || `switcher-${counter}`;
    $element.attr('id', id);

    const label = angular.element(`<label for="${id}"></label>`);
    $element.after(label);
    counter++;
  };
}
